import React from 'react';
import { CardTitle, CardSubhead } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import styled from 'styled-components';

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const AnexosHeader = ({
  totalRegistros,
  onExportarPendencias,
  exportarPendenciasLoading,
  selectedCount,
  onMostrarDocumentacao,
  documentacaoLoading,
}) => {
  return (
    <HeaderWrap>
      <div>
        <TitleRow>
          <CardTitle className="mb-0">Anexos</CardTitle>
          {onMostrarDocumentacao && (
            <Tooltip dir="top" text="Ajuda do modulo">
              <span className="d-inline-flex align-items-center">
                <HelpButton
                  type="button"
                  onClick={onMostrarDocumentacao}
                  disabled={documentacaoLoading}
                  aria-label="Ajuda do modulo anexos"
                >
                  <Icon name={documentacaoLoading ? 'loading' : 'information-outline'} size={16} />
                </HelpButton>
              </span>
            </Tooltip>
          )}
        </TitleRow>
          <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
      </div>
      <ButtonContainer>
        {onExportarPendencias && (
          <ButtonWithLoading
            variant="outline-primary"
            onClick={onExportarPendencias}
            loading={exportarPendenciasLoading}
            disabled={totalRegistros === 0 || !selectedCount}
          >
            Exportar Anexos
          </ButtonWithLoading>
        )}
      </ButtonContainer>
    </HeaderWrap>
  );
};

export default AnexosHeader;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const TitleRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const HelpButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  color: inherit;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    opacity: 0.8;
  }
`;
